











































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Action, Getter, State } from 'vuex-class'

import {
  CreateOptionModal,
  InfiniteScroll,
  NetworkErrorEmptyState,
  OptionTile,
  VsLoading
} from '@/components'

import { EmptyState, MobileLayout } from '@/layouts/components'

import {
  AsyncState,
  ModalState,
  Option,
  OptionOuterContext
} from '@/models'

import { OptionGroupOptions } from '@/store/menu/state'
import { RelationMap } from '@/store/models'
import { RootState } from '@/store/state'
import { isFood } from '@/utils'

@Component({
  components: {
    CreateOptionModal,
    EmptyState,
    InfiniteScroll,
    MobileLayout,
    NetworkErrorEmptyState,
    OptionTile,
    VsLoading
  }
})
export default class Options extends Vue {
  @Prop({ type: Number, required: true })
  readonly itemGroupId!: number

  @Prop({ type: Number, required: true })
  readonly optionGroupId!: number

  loadState = new AsyncState()
  createState = new ModalState()

  get optionGroupOptions (): OptionGroupOptions | undefined {
    return this.optionGroupsOptions[this.optionGroupId]
  }

  get options () {
    return this.orderedOptions(this.optionGroupId)
  }

  get showFab () {
    return this.total > 0 || this.loadState.isResolved
  }

  get total () {
    return this.optionGroupOptions
      ? this.optionGroupOptions.total
      : 0
  }

  get emptyStateIcon () {
    return isFood() ? 'restaurant_menu' : 'list_alt'
  }

  @State((state: RootState) => state.menu.optionGroups.options)
  readonly optionGroupsOptions!: RelationMap<OptionGroupOptions>

  @Getter('menu/orderedOptions')
  readonly orderedOptions!: (optionGroupId: number) => Option[]

  @Action('menu/loadOptionPage')
  loadOptionPage!: (context: OptionOuterContext) => Promise<void>

  created () {
    if (this.total === 0) {
      this.reload()
    } else {
      this.loadState.touch()
    }
  }

  async reload () {
    try {
      await this.loadMore()
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  async loadMore () {
    await this.loadState.handle(
      this.loadOptionPage({
        optionGroupId: this.optionGroupId,
        itemGroupId: this.itemGroupId
      })
    )

    return this.options.length > 0
  }
}
